// ==============================|| UTILITIES MENU ITEMS ||============================== //

import { HelpOutline, SettingsOutlined } from '@mui/icons-material'

const utilities = {
  id: 'utilities',
  type: 'group',
  children: [
    {
      id: 'menu-help',
      title: 'Help',
      type: 'item',
      url: '//dotaudiences.com/support',
      icon: <HelpOutline />,
      target: '_blank',
      linkIcon: null,
      subRoutes: []
    },
    {
      id: 'menu-settings',
      title: 'Settings',
      type: 'item',
      url: '/settings',
      icon: <SettingsOutlined />,
      linkIcon: null,
      subRoutes: ['/settings']
    }
  ]
}

export default utilities
